/**
 * Resolves a protocol-relative URL (`//host/path`) to an absolute one using
 * the current page's protocol. Absolute URLs are returned unchanged.
 */
export function resolveAbsoluteUrl(url: string): string {
	if (!url.startsWith("//")) {
		return url
	}

	if (typeof window !== "undefined") {
		return `${window.location.protocol}${url}`
	}

	return `https:${url}`
}
